module.exports = __webpack_public_path__ + "img/sk-veb-ru.6e292f0.svg";